import {useEffect} from "react";

const useSaveLastStation = (currentStation) => {
	useEffect(() => {
		if (currentStation && currentStation.id) {
			localStorage.setItem("lastStationId", String(currentStation.id));
		}
	}, [currentStation]);
}

export default useSaveLastStation;